export enum DiagramTransaction {
  CLEAR_DIAGRAM = 'CLEAR_DIAGRAM',
  COLLABORATION_SYNC = 'COLLABORATION_SYNC',
  SET_DIAGRAM_HIGHLIGHT = 'SET_DIAGRAM_HIGHLIGHT',
  SET_DIAGRAM_SELECTION = 'SET_DIAGRAM_SELECTION',
  SET_MODEL_HIGHLIGHT = 'SET_MODEL_HIGHLIGHT',
  SET_MODEL_SELECTION = 'SET_MODEL_SELECTION',
  TOGGLE_ATTRIBUTES_PANEL = 'TOGGLE_ATTRIBUTES_PANEL',
}

export const transactionsToSkipProjectDiagramUpdate =
  new Set<DiagramTransaction>([
    DiagramTransaction.CLEAR_DIAGRAM,
    DiagramTransaction.COLLABORATION_SYNC,
    DiagramTransaction.SET_DIAGRAM_HIGHLIGHT,
    DiagramTransaction.SET_DIAGRAM_SELECTION,
    DiagramTransaction.SET_MODEL_HIGHLIGHT,
    DiagramTransaction.SET_MODEL_SELECTION,
    DiagramTransaction.TOGGLE_ATTRIBUTES_PANEL,
  ]);
